import "./LastLogin.scss"
import colors from '../../../assets/scss/variable/color.scss';
import {default as _} from "../../../helpers/Translate"
import {useDispatch} from 'react-redux';
import {useEffect, useState} from "react";
import BaseApi from "../../../core/api/BaseApi";
import snippets from "../../../helpers/snippets";
import T from "../../../shared/component/t/T";
import Modal from "../../../shared/component/Modal/Modal";
import {_loading} from "../../../actions/Loading";
import {_alert} from "../../../actions/Alert";

const baseApi = new BaseApi()
const LastLoginModal = ({open, closeModalProp}) => {
    const dispatch = useDispatch();
    const [show, setShow] = useState(false)
    const [sessions, setSessions] = useState([])
    
    useEffect(() => {
        if (open) moreClicked()
    }, [open])
    
    useEffect(() => {
        if (show) dispatch(_loading(false));
    }, [show])
    
    const moreClicked = () => {
        dispatch(_loading(true));
        baseApi.fullFetch('login', 'get', {data: {last_sessions: true}}).then(response => {
            setSessions(response.data.sessions)
            if (!snippets.isObjectEmpty(response.data.sessions)) setShow(true)
        }).catch(e => {
            console.error('getting last sessions fails', e)
            dispatch(_loading(false));
			closeModalProp()
        })
    }
    
    const closeModal = () => {
        setShow(false)
	    closeModalProp()
    }
    
	
	const closeSession = (session) => {
		dispatch(_loading(true));
        baseApi.fullFetch('login', 'delete', {data: {session_id: session?.id}}).then(response => {
			dispatch(_alert(true, 'success', <T token={"session_was_terminated"} />));
			moreClicked()
        }).catch(e => {
			dispatch(_alert(true, 'error', <T token={"session_was_not_terminated"} />));
			dispatch(_loading(false));
        })
	}
	
	const closeSessionButtonHandler = (session) => {
		if (session.is_active && !session.is_current) {
			return <div onClick={()=>closeSession(session)} title={_.init('close_session')}>
				<i className={'fal fa-hand-scissors fa-shake fa-shake-hover'} />
				</div>
		} else {
			return <T token={session?.comment} />
		}
	}
    
    const recentSessions = () => {
        const footer = <div className={'imodal__action'}>
            <div className={'imodal__btn imodal__btn--secondary'}
                 onClick={closeModal}><T token={'close'}/>
            </div>
        </div>
        
        
        return <>
            <Modal show={show}
                   className={'report_history_modal'}
                   closeModal={closeModal}
                   title='recent_sessions'
                   closeable={true}
                   footer={footer}
            >
                
                <div className={'imodal recent_sessions'}>
                    <div className={'imodal__body recent_sessions_body'}>
                        <div className="table-responsive">
                            <table className="table table-dark table-hover text-center">
                                <thead>
                                <tr>
                                    <th scope="col"><T token={'rows'}/></th>
                                    <th scope="col"><T token={'date'}/></th>
                                    <th scope="col"><T token={'hour'}/></th>
                                    <th scope="col"><T token={'login_status'}/></th>
                                    <th scope="col"><T token={'ip'}/></th>
                                    <th scope="col"><T token={'status'}/></th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    sessions?.map((item, index) => <tr className={item.is_current ? 'table-active': ''} key={index}>
                                        <td>{_.init3(index+1)}</td>
                                        <td>{_.datetime(item.create_date)}</td>
                                        <td>{_.datetime2time(item.create_date)}</td>
                                        <td>{item.is_succeeded ?
                                          <i className={'fal fa-check-circle'}
                                             style={{color: colors.excel}}
                                             title={_.init('login_succeed')}
                                          /> :
                                          <i className={'fal fa-times-circle'}
                                             style={{color: colors.redLight}}
                                             title={_.init('login_failed')}
                                          />}
                                        </td>
                                        <td>{item.ip}</td>
                                        <td>{closeSessionButtonHandler(item)}</td>
                                    </tr>)
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    }
    
    return recentSessions();
}

export default LastLoginModal;